import "./logo.css";
import logo from "../../../assets/Logo.svg";

function Logo() {
  return (
    <>
      <div className="container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <img src={logo} alt="logo" className="img-fluid"></img>
          </div>
        </div>
      </div>
    </>
  );
}
export default Logo;
